import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=5ea2c617&"
import script from "./emptyData.vue?vue&type=script&lang=js&"
export * from "./emptyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "output/emptyData.vue"
export default component.exports